import React from 'react';
import { useMediaQuery } from 'react-responsive';
import config from './config';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({
    minWidth: config.desktop.minWidth,
  });
  return isDesktop ? children : null;
};

export default Desktop;
